import {
    AreaNotificationMessage,
    Button,
    JobStatusLabel,
    MobilePage,
    MobilePageActions,
    MobilePageSection,
} from "@relode/core";
import * as React from "react";
import styled from "styled-components";

import { useClientPublicJobContext } from "../_infra";
import { ClientPublicJobDetailsProps } from "./clientPublicJobDetailsProps";
import { ClientPublicJobInsights } from "./clientPublicJobInsights";
import { ClientPublicJobOverview } from "./clientPublicJobOverview";
import { ClientPublicJobQualifications } from "./clientPublicJobQualifications";

export const ClientPublicJobDetailsMobile = (
    props: ClientPublicJobDetailsProps
) => {
    const {
        state: {
            data: { job },
            ui: { fetchState },
            ui,
        },
    } = useClientPublicJobContext();

    const renderFooter = (): React.ReactNode => (
        <Button
            size="small"
            color="primary"
            variant="contained"
            fullWidth
            onClick={props.onSignIn}
        >
            sign in
        </Button>
    );

    if (fetchState === "error") {
        return (
            <MobilePage
                actions={<MobilePageActions title="job not found" />}
                footerActions={renderFooter}
            >
                <AreaNotificationContainer>
                    <AreaNotificationMessage level="error">
                        {ui.error.isBadRequest() ? (
                            <>{ui.error.friendlyMessages}</>
                        ) : (
                            <>
                                The information you are looking for cannot be
                                found. Contact support at{" "}
                                <a
                                    href="mailto:support@relode.com"
                                    target="_blank"
                                >
                                    support@relode.com
                                </a>{" "}
                                if you have any questions.
                            </>
                        )}
                    </AreaNotificationMessage>
                </AreaNotificationContainer>
            </MobilePage>
        );
    }

    if (!job) return null;

    return (
        <MobilePage
            showTabs={true}
            defaultSection={"insights"}
            isBusy={fetchState === "loading"}
            actions={
                <MobilePageActions
                    title={job?.details ? job.details.jobName : "n/a"}
                    statusLabel={
                        job?.details && job.details.jobStatus ? (
                            <JobStatusLabel
                                title={job.details.jobStatus.description}
                                jobStatus={job.details.jobStatus}
                            />
                        ) : null
                    }
                ></MobilePageActions>
            }
            footerActions={renderFooter}
        >
            <MobilePageSection label="details" id="details">
                <ClientPublicJobOverview />
            </MobilePageSection>

            <MobilePageSection label="quals" id="quals">
                <ClientPublicJobQualifications />
            </MobilePageSection>

            <MobilePageSection label="insights" id="insights">
                <ClientPublicJobInsights />
            </MobilePageSection>
        </MobilePage>
    );
};

const AreaNotificationContainer = styled.div`
    margin-top: 16px;
`;
